import React from 'react';
import { motion } from 'framer-motion';
const examples = [{
  title: 'Mini Pote de Doce de Leite',
  image: 'https://i.ibb.co/ccdJ5wmY/Lembrancinha-Rustica-Com-Doce-De-Leite-120ml-Com-Folha-Aniversario-E-Festas-Festa-Fazendinha-Abr.jpg'
}, {
  title: 'Mini Terrário',
  image: 'https://i.ibb.co/gZcXWFgp/download-5.jpg'
}, {
  title: 'Amêndoas',
  image: 'https://i.ibb.co/rKrs2Kby/download-10.jpg'
}, {
  title: 'Sal de Banho',
  image: 'https://i.ibb.co/d0Dd1yQm/Whats-App-Image-2025-12-01-at-19-07-27-1.jpg'
}];
const testimonials = ['"Isso é de boutique MESMO? Parece que custou caro!"', '"Meu Deus, ficou idêntico ao que a loja vende por R$ 14."', '"Eu nunca imaginei que dava pra fazer isso tão barato."', '"Eu fiz as amêndoas premium e TODO MUNDO comentou!"'];
export function ExamplesSection() {
  return <section className="py-24 bg-gradient-to-br from-gray-50 to-rose-50" data-id="element-1">
      <div className="max-w-6xl mx-auto px-6" data-id="element-2">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-3">
          <h2 className="font-serif text-4xl md:text-5xl font-bold text-gray-900 mb-6" data-id="element-4">
            Essas são lembrancinhas que fazem qualquer convidado achar que você
            gastou uma fortuna
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto" data-id="element-5">
            São apenas alguns exemplos do guia e todos feitos em casa
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-6">
          {examples.map((example, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1,
          duration: 0.5
        }} className="bg-white rounded-2xl shadow-lg overflow-hidden group" data-id="element-7">
              <div className="aspect-square overflow-hidden" data-id="element-8">
                <img src={example.image} alt={example.title} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110" data-id="element-9" />
              </div>
              <div className="p-6" data-id="element-10">
                <h3 className="text-lg font-semibold text-gray-900 text-center" data-id="element-11">
                  {example.title}
                </h3>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.5,
        duration: 0.6
      }} className="mt-12 text-center" data-id="element-12">
          <p className="text-lg text-gray-600 italic" data-id="element-13">
            "Apenas 4 das 40 ideias completas que você vai receber!"
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.6,
        duration: 0.6
      }} className="mt-20" data-id="element-14">
          <h3 className="text-2xl md:text-3xl font-bold text-gray-900 text-center mb-12" data-id="element-15">
            O que outras noivas disseram ao ver essas ideias:
          </h3>

          <div className="grid md:grid-cols-2 gap-6 mb-12" data-id="element-16">
            {testimonials.map((testimonial, index) => <motion.div key={index} initial={{
            opacity: 0,
            x: index % 2 === 0 ? -20 : 20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1,
            duration: 0.5
          }} className="bg-white p-6 rounded-xl shadow-md" data-id="element-17">
                <div className="flex items-start gap-3" data-id="element-18">
                  <span className="text-2xl" data-id="element-19">💬</span>
                  <p className="text-lg text-gray-700 italic" data-id="element-20">{testimonial}</p>
                </div>
              </motion.div>)}
          </div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.8,
          duration: 0.6
        }} className="text-center" data-id="element-21">
            <p className="text-xl text-gray-800 leading-relaxed max-w-2xl mx-auto" data-id="element-22">
              Esses comentários não acontecem por acaso —{' '}
              <span className="font-bold text-rose-600" data-id="element-23">
                é o acabamento que engana até fornecedor.
              </span>
            </p>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}